import * as React from 'react';
import { SVGProps } from 'react';

const IconYandexDzenSizeXs = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M1 5.899c2.057-.024 3.208-.158 3.974-.925.766-.766.901-1.917.925-3.974A5.001 5.001 0 0 0 1 5.899ZM6.197 1.003c.024 2.055.159 3.205.925 3.971.754.755 1.881.897 3.878.924a5.001 5.001 0 0 0-4.803-4.895ZM10.997 6.199c-1.995.027-3.121.17-3.875.923-.754.754-.896 1.88-.923 3.875A5.001 5.001 0 0 0 10.997 6.2ZM5.898 11c-.027-1.997-.17-3.124-.924-3.878-.766-.766-1.916-.9-3.971-.925A5.001 5.001 0 0 0 5.898 11Z" />
  </svg>
);
export default IconYandexDzenSizeXs;
